import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import {
  ForgotPasswordForm,
  type ForgotPasswordFormValues,
} from "./components/ForgotPasswordForm";
import { postRodauth, rodauthSuccess } from "@/lib/rodauth";

export default function ForgotPasswordPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (values: ForgotPasswordFormValues) => {
    setLoading(true);
    setError(null);

    try {
      const response = await postRodauth("/reset-password-request", {
        email: values.email,
      });

      if (rodauthSuccess(response)) {
        setSuccess(true);
      } else {
        setError("Não foi possível enviar o e-mail. Tente novamente.");
      }
    } catch {
      setError("Erro ao enviar solicitação. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-primary-50 dark:bg-primary-950 flex items-center justify-center px-4">
      <Card className="max-w-md w-full p-6 sm:p-12">
        <CardContent className="p-0">
          <h1 className="text-3xl font-light tracking-tight text-primary-950 dark:text-white mb-2">
            ESQUECI A SENHA
          </h1>
          <p className="text-sm font-light text-primary-600 dark:text-primary-400 mb-8">
            Enviaremos um link para redefinir sua senha
          </p>
          <ForgotPasswordForm
            onSubmit={handleSubmit}
            loading={loading}
            error={error}
            success={success}
          />
        </CardContent>
      </Card>
    </div>
  );
}
